import { Button, Result, Typography } from 'antd';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';

import type { ResultStatusType } from 'antd/es/result';

const { Paragraph, Text } = Typography;

export const ErrorPage = () => {
  const error = useRouteError();

  let title = 'Что-то пошло не так';
  let subTitle =
    'Произошла непредвиденная ошибка. Попробуйте обновить страницу.';
  let stack: string | undefined;
  let status: ResultStatusType = '500';

  if (isRouteErrorResponse(error)) {
    status = (error?.status?.toString() as ResultStatusType) || '500';
    title = `Ошибка ${error.status}`;
    subTitle = error.statusText || subTitle;
  } else if (error instanceof Error) {
    subTitle = error.message;
    stack = error?.stack || undefined;
  }

  const handleReload = () => window.location.reload();

  return (
    <div
      style={{
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Result
        status={status}
        title={title}
        subTitle={subTitle}
        extra={
          <Button type="primary" onClick={handleReload}>
            Обновить страницу
          </Button>
        }
        style={{ width: '100%' }}
      >
        {!!stack && (
          <div>
            <Paragraph>
              <Text type="secondary">Stack trace:</Text>
            </Paragraph>
            <pre
              style={{
                background: '#f5f5f5',
                borderRadius: 6,
                overflowX: 'auto',
              }}
            >
              {stack}
            </pre>
          </div>
        )}
      </Result>
    </div>
  );
};
